import { useState } from 'react';
import { cn, initials } from '@/lib/utils';
import './Avatar.css';

export type AvatarSize = 'sm' | 'md' | 'lg';

export interface AvatarProps {
  name: string;
  /** Optional image URL; falls back to initials on error or absence. */
  src?: string | null;
  size?: AvatarSize;
  className?: string;
}

const PX: Record<AvatarSize, number> = { sm: 24, md: 32, lg: 40 };

/**
 * Selo de identidade: a imagem quando há, senão as iniciais na cor da marca.
 * Uma URL expirada ou uma imagem quebrada volta às iniciais, nunca ao ícone de
 * arquivo ausente. Decorativo para tecnologia assistiva — o nome aparece ao lado.
 */
export function Avatar({ name, src, size = 'md', className }: AvatarProps): JSX.Element {
  const px = PX[size];
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const showImage = Boolean(src && failedSrc !== src);

  return (
    <span
      className={cn('avatar', `avatar--${size}`, className)}
      style={{ width: px, height: px }}
      aria-hidden="true"
    >
      {showImage ? (
        <img className="avatar__img" src={src!} alt="" onError={() => setFailedSrc(src!)} />
      ) : (
        <span>{initials(name)}</span>
      )}
    </span>
  );
}
